
import { Component, Vue } from 'vue-property-decorator'
@Component
export default class DonationEmailInfoCheckbox extends Vue {
  accepted = false
  declined = false

  accept (value: boolean) {
    if (value) {
      this.declined = false
      this.accepted = true
      this.$emit("change", false)
    } else {
      this.accepted = false
      this.$emit("change", true)
    }
  }

  decline (value: boolean) {
    if (value) {
      this.accepted = false
      this.declined = true
      this.$emit("change", true)
    } else {
      this.declined = false
      this.$emit("change", false)
    }
  }
}
